import React from "react";
import { BsPlusLg } from "react-icons/bs";
import Bag from "../assets/svg/bag.svg";
import Popup from "reactjs-popup";
import AddBusiness from "./Form/Others/AddBusiness";
import { FeedBusiness } from ".";
import { useBusiness } from "../context/BusinessContext";
import EditBusiness from "./Form/Others/EditBusiness";


const FeedBusinesses = () => {

  const { businesses, selectedBusiness, setLoadMyBusinesses, loadMyBusinesses, mybusinesses } = useBusiness();
  return (
    <div>
      <div className="flex items-center pb-5">
        <div className={`flex items-center border-2 rounded-xl py-3 px-5 mr-3 cursor-pointer ${loadMyBusinesses ? 'border-primary' : ''}`} onClick={() => setLoadMyBusinesses(prev => !prev)}>
          <img src={Bag} alt="business" className="text-2xl" />
          <p className="text-sm pl-3">My Business</p>
        </div>
        <Popup
          trigger={
            <div className="flex items-center border-2 rounded-xl py-3 px-5 mr-3 cursor-pointer text-primary">
              <BsPlusLg className="text-xl" />
              <p className="text-sm pl-3">Add</p>
            </div>
          }
          position="right center"
          modal
          closeOnDocumentClick={false}
          nested
          contentStyle={{
            borderRadius: "12px",
            backgroundColor: "white",
            width: "fit-content",
            fontSize: "0.8rem",
            maxHeight: "98%",
            overflow: "auto",
          }}
        >
          {(close) => <AddBusiness close={close} />}
        </Popup>

        <Popup
          open={selectedBusiness !== null}
          position="right center"
          modal
          closeOnDocumentClick={false}
          nested
          contentStyle={{
            borderRadius: "12px",
            backgroundColor: "white",
            width: "fit-content",
            fontSize: "0.8rem",
            maxHeight: "98%",
            overflow: "auto",
          }}
        >
          {(close) => <EditBusiness close={close} />}
        </Popup>
      </div>

      <div>
        {!loadMyBusinesses ? businesses.map((business) => (
          <FeedBusiness business={business} />
        )) : mybusinesses.map((business) => (
          <FeedBusiness business={business} />
        )) }
      </div>
    </div>
  );
};

export default FeedBusinesses;
